export default __webpack_public_path__ + "static/media/3132 knife block B top.6fc06c4f.png";